import React from 'react';
import { motion } from 'framer-motion';
import { MoreHorizontal, Calendar, ExternalLink } from 'lucide-react';
type Task = {
  id: string;
  domain: string;
  da: number;
  date: string;
  status: 'discovered' | 'outreach' | 'pending' | 'published';
};
const columns = [{
  id: 'discovered',
  title: 'Discovered',
  color: 'bg-gray-500'
}, {
  id: 'outreach',
  title: 'Outreach',
  color: 'bg-blue-500'
}, {
  id: 'pending',
  title: 'Pending',
  color: 'bg-amber-500'
}, {
  id: 'published',
  title: 'Published',
  color: 'bg-green-500'
}];
const tasks: Task[] = [{
  id: '1',
  domain: 'techcrunch.com',
  da: 92,
  date: '2 days ago',
  status: 'discovered'
}, {
  id: '2',
  domain: 'indiehackers.com',
  da: 78,
  date: '1 day ago',
  status: 'discovered'
}, {
  id: '3',
  domain: 'dev.to',
  da: 85,
  date: '3 days ago',
  status: 'outreach'
}, {
  id: '4',
  domain: 'hashnode.com',
  da: 72,
  date: '5 days ago',
  status: 'outreach'
}, {
  id: '5',
  domain: 'medium.com',
  da: 95,
  date: '1 week ago',
  status: 'pending'
}, {
  id: '6',
  domain: 'smashingmagazine.com',
  da: 88,
  date: '2 weeks ago',
  status: 'published'
}];
export function BacklinkKanban() {
  return <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 h-full min-h-[600px]" data-id="element-1">
      <div className="flex items-center justify-between mb-6" data-id="element-2">
        <h3 className="text-lg font-semibold text-white flex items-center gap-2" data-id="element-3">
          <span className="w-1 h-4 bg-amber-500 rounded-full" data-id="element-4" />
          Outreach Pipeline
        </h3>
        <button className="text-xs text-white/50 hover:text-white transition-colors" data-id="element-5">
          View All
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 h-full" data-id="element-6">
        {columns.map(col => <div key={col.id} className="flex flex-col h-full" data-id="element-7">
            <div className="flex items-center justify-between mb-4 px-2" data-id="element-8">
              <div className="flex items-center gap-2" data-id="element-9">
                <div className={`w-2 h-2 rounded-full ${col.color}`} data-id="element-10" />
                <span className="text-sm font-medium text-white/70" data-id="element-11">
                  {col.title}
                </span>
              </div>
              <span className="text-xs text-white/30 bg-white/5 px-2 py-0.5 rounded-full" data-id="element-12">
                {tasks.filter(t => t.status === col.id).length}
              </span>
            </div>

            <div className="flex-1 bg-black/20 rounded-xl p-2 space-y-3" data-id="element-13">
              {tasks.filter(t => t.status === col.id).map((task, index) => <motion.div key={task.id} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1a1a1a] border border-white/5 hover:border-amber-500/30 rounded-lg p-3 group cursor-pointer transition-all duration-200 hover:shadow-lg hover:shadow-amber-900/10 hover:-translate-y-1" data-id="element-14">
                    <div className="flex justify-between items-start mb-2" data-id="element-15">
                      <span className="text-sm font-medium text-white group-hover:text-amber-400 transition-colors" data-id="element-16">
                        {task.domain}
                      </span>
                      <button className="text-white/20 hover:text-white transition-colors" data-id="element-17">
                        <MoreHorizontal className="w-4 h-4" data-id="element-18" />
                      </button>
                    </div>

                    <div className="flex items-center gap-2 mb-3" data-id="element-19">
                      <span className="text-xs font-semibold bg-white/5 text-white/60 px-1.5 py-0.5 rounded border border-white/5" data-id="element-20">
                        DA {task.da}
                      </span>
                    </div>

                    <div className="flex items-center justify-between text-xs text-white/30 pt-2 border-t border-white/5" data-id="element-21">
                      <div className="flex items-center gap-1" data-id="element-22">
                        <Calendar className="w-3 h-3" data-id="element-23" />
                        {task.date}
                      </div>
                      <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-24" />
                    </div>
                  </motion.div>)}

              {tasks.filter(t => t.status === col.id).length === 0 && <div className="h-24 flex items-center justify-center border-2 border-dashed border-white/5 rounded-lg" data-id="element-25">
                  <span className="text-xs text-white/20" data-id="element-26">No items</span>
                </div>}
            </div>
          </div>)}
      </div>
    </div>;
}